import React from "react";
import { StarIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { testimonials } from "../../data/content";
export function Testimonials() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-20" data-id="element-304" data-mp="3mf7pufvy5mbi">
      <div className="mx-auto max-w-5xl" data-id="element-305" data-mp="3r80w5872d2pp">
        <SectionHeading eyebrow="From students using the system" title={<>Less Time Organizing, <em className="text-forest" data-id="element-307" data-mp="xzi18gi483">More Time Studying</em></>} data-id="element-306" data-mp="3r8trze4hi7t2" />

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-308" data-mp="41hxf70utbva">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_8px_30px_-14px_rgba(20,33,30,0.2)] ring-1 ring-ink/5" data-id="element-309" data-mp="937cqyv40bp6">
              <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-310" data-mp="2at910nij9hcp">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-311" data-mp="2ft550mr8d8s9" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[16px] leading-relaxed text-ink" data-id="element-312" data-mp="1slu9uhiq8hep">“{t.quote}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-ink/10 pt-5" data-id="element-313" data-mp="1nrzpdbvaryek">
                <img src={t.image} alt={t.name} className="h-14 w-14 rounded-full object-cover ring-2 ring-sage" loading="lazy" data-id="element-314" data-mp="1isn0klkv8h9c" />
                <div data-id="element-315" data-mp="2bjx1l42nssg7">
                  <p className="font-bold text-ink" data-id="element-316" data-mp="2bic87hs2zfjx">{t.name}</p>
                  <p className="text-[14px] text-muted" data-id="element-317" data-mp="26kalmmvg4y3p">{t.location}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-10" data-id="element-318" data-mp="22gvx17tfz9en">
          <CtaButton label="I want to organize my studies too" data-id="element-319" data-mp="1xjm6tpy8atpr" />
        </div>
      </div>
    </section>;
}